import { GlobalFun } from '@/common/utils';
import Axios from 'axios';
import { vm } from '../main';

const http = Axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    baseURL: 'http://mallmgr.cesseon.com/api/',
    // baseURL: 'http://vps2.seekersoft.cn:8543/api/',
    headers: {
        'Content-Type': 'application/json'
    }
    //withCredentials: true
});

http.interceptors.request.use(
    async config => {
        const userinfo = await GlobalFun.getCookie('UserInfo');
        if (!userinfo) {
            //logout('登录超时。', true);
            //alert('沒有userinfo');
        } else {
            config.headers['ticket'] = userinfo.Ticket; //ticket
        }
        // 时间戳
        // if (config.method === 'post') {
        //     config.data = {
        //         ...config.data,
        //         t: Date.parse(new Date()) / 1000
        //     };
        // } else if (config.method === 'get') {
        //     config.params = {
        //         t: Date.parse(new Date()) / 1000,
        //         ...config.params
        //     };
        // }
        //console.log(config);
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

http.interceptors.response.use(
    response => {
        if (response.status === 200) {
            switch (response.data.Status) {
                case -2:
                    logout('没有权限', false);
                    return Promise.reject();
                case -1:
                    logout('登入超时（未登入）', true);
                    return Promise.reject();
                case 1:
                    return response.data.Data;
                case 0:
                    logout(response.data.Msg, false);
                    return Promise.reject();
                case 2:
                    logout('频繁操作', false);
                    return Promise.reject();
            }
        } else {
            return Promise.reject();
        }
    },
    () => {
        logout('服务器未响应', false);
        return Promise.reject();
    }
);

function logout(msg, isLogout) {
    vm.$message({
        message: msg,
        type: 'error'
    });
    if (isLogout) {
        vm.$router.push('/login');
    }
}

export { http };
